import { Injectable } from '@angular/core';
import { FUNCTIONS_NAMESPACE } from '../interfaces/imetadata';
import { ImageFieldType } from '../utils/fieldconfig';
import { FieldContext } from '../utils/fieldcontext';
import { templateContext } from '../utils/template-context';
import { ApplicationStoreService } from './application-store.service';
import { FunctionsModelService } from './functions-model.service';

@Injectable({ providedIn: 'root' })
export class ImageFieldsService {
  constructor(private applicationStoreService: ApplicationStoreService, private functionsModelService: FunctionsModelService) {}

  async insert(fieldContext: FieldContext): Promise<FieldContext> {
    if (!fieldContext.isImageField) {
      return fieldContext;
    }

    // at this point the image field config has only the type and value set

    const imageFieldConfig = fieldContext.imageFieldConfig!;

    if (imageFieldConfig.type === ImageFieldType.FILE_TYPE) {
      const templateTargetEntity = templateContext.getTargetEntity().entity;
      const refId = await this.applicationStoreService.incrementRefId();
      const fieldPath = `${FUNCTIONS_NAMESPACE}.${fieldContext.namespace}.image_${refId}`;
      const functionConfig = {
        name: 'queryForFileData',
        entityType: templateTargetEntity,
        fileType: imageFieldConfig.value,
        out: fieldPath,
      };
      imageFieldConfig.functionId = await this.functionsModelService.insert(fieldContext.namespace, fieldContext.namespace, functionConfig);
      fieldContext.field.path = fieldPath; // leaf is used by the model part as the element name
    }

    return fieldContext;
  }

  async update(fieldContext: FieldContext): Promise<FieldContext> {
    if (!fieldContext.isImageField) {
      return fieldContext;
    }

    const imageFieldConfig = fieldContext.imageFieldConfig!;

    if (imageFieldConfig.type === ImageFieldType.FILE_TYPE) {
      const oldFunc = await this.functionsModelService.delete(fieldContext.namespace, fieldContext.imageFieldConfig!.functionId);
      const templateTargetEntity = templateContext.getTargetEntity().entity;
      const functionConfig = {
        name: 'queryForFileData',
        entityType: templateTargetEntity,
        fileType: imageFieldConfig.value,
        out: oldFunc?.config.out,
      };
      imageFieldConfig.functionId = await this.functionsModelService.insert(fieldContext.namespace, fieldContext.namespace, functionConfig);
    }

    return fieldContext;
  }
}
